import Main from './pages/Main/Main';
// test vscode online
function App() {
  return (
      <Main />
  );
}

export default App;
